export default __webpack_public_path__ + "static/media/grd_new_header.a8553621.png";